import { createSelector } from '@ngrx/store';

import { membersState } from '../root';

export const getMemberState = createSelector(membersState, (members) => members);
